module.exports = __webpack_public_path__ + "static/app_store_border-821f222190b4e32f61e354a5c65809c3.png";